import { SiteBuilderDialog } from '../../static_war/sitebuilder-dialog/SiteBuilderDialog';

const TAG_NAME = 'sb-dialog-wrapper';

/**
 * Wrap your <dialog> elements in this to make sure it's set up properly. I've added methods to it that pass on to the
 * wrapped <dialog> (i.e. showModal(), close() etc) to try to catch any cases where these are called on the wrong element.
 */
export class SbDialogWrapper extends HTMLElement {
  wantsToShowModal: boolean = false;
  wantsToShow: boolean = false;
  dialogElement: HTMLDialogElement | null = null;

  constructor() {
    super();
  }

  connectedCallback() {
    if (!this.isConnected) {
      return;
    }

    if (!this.dialogElement) {
      this.dialogElement = this.querySelector(':scope > dialog');
    }

    if (!this.dialogElement) {
      throw new Error('sb-dialog-wrapper must contain a <dialog> element as a child');
    }

    // The registration process will kick the <dialog> out to the document <body> so that old versions of Safari won't be upset
    if (!SiteBuilderDialog.isAlreadyRegistered(this.dialogElement)) {
      new SiteBuilderDialog(this.dialogElement);
    }

    // Bit of a faff but stops bad race condition stuff with all the initialising and connecting we've got going on
    if (this.wantsToShow) {
      this.show();
      this.wantsToShow = false;
    } else if (this.wantsToShowModal) {
      this.showModal();
      this.wantsToShowModal = false;
    }
  }

  show() {
    if (!this.isConnected) {
      this.wantsToShow = true;
    } else {
      this.dialogElement.show();
    }
  }

  showModal() {
    if (!this.isConnected) {
      this.wantsToShowModal = true;
    } else {
      this.dialogElement.showModal();
    }
  }

  close() {
    this.dialogElement.close();
  }

  get open(): boolean {
    return this.dialogElement.open;
  }
}

window.customElements.define(TAG_NAME, SbDialogWrapper);
